import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Calendar } from 'lucide-react';
import { bookingUrl } from '../data/mock';
import useScrollFlag from '../hooks/useScrollFlag';

const navItems = [
  { to: '/', label: 'Accueil' },
  { to: '/cabinet', label: 'Le cabinet' },
  { to: '/services', label: 'Nos services' },
  { to: '/actualites', label: 'Actualités' },
  { to: '/faq', label: 'FAQ' },
  { to: '/nous-rejoindre', label: 'Nous rejoindre' },
  { to: '/contact', label: 'Contact' }
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const scrolled = useScrollFlag(20);
  const location = useLocation();
  const { pathname } = location;
  useEffect(() => { setOpen(false); }, [pathname, setOpen]);
  const isHome = pathname === '/';
  const useDark = scrolled || !isHome;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${useDark ? 'bg-[#010c23] shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex items-center justify-between py-2">
        <Link to="/" className="flex items-center" aria-label="Ometis Patrimoine — Accueil" data-testid="header-logo">
          <img src="/logo-transparent.png" alt="Ometis Patrimoine" className="h-16 md:h-[84px] w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <Link key={item.to} to={item.to} aria-current={location.pathname === item.to ? 'page' : undefined} data-testid={`nav-${item.to === '/' ? 'home' : item.to.slice(1)}`} className={`text-sm tracking-wider font-medium link-underline transition-colors ${location.pathname === item.to ? 'text-[#ff7300]' : 'text-white/90 hover:text-white'}`}>{item.label}</Link>
          ))}
        </nav>
        <a href={bookingUrl} target="_blank" rel="noreferrer" className="hidden lg:inline-flex items-center gap-2 border border-[#ff7300] text-[#ff7300] hover:bg-[#ff7300] hover:text-white transition-colors duration-300 px-5 py-2.5 text-sm font-medium tracking-wider rounded-sm">
          <Calendar size={15} /> Prendre rendez-vous en ligne
        </a>
        <button onClick={() => setOpen(!open)} className="lg:hidden text-white p-2 -mr-2" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} aria-expanded={open} data-testid="mobile-menu-button">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#010c23] border-t border-white/10">
          <nav className="flex flex-col px-6 py-6 gap-5">
            {navItems.map((item) => (
              <Link key={item.to} to={item.to} className={`text-base tracking-wider font-medium ${location.pathname === item.to ? 'text-[#ff7300]' : 'text-white/90'}`}>{item.label}</Link>
            ))}
            <a href={bookingUrl} target="_blank" rel="noreferrer" className="mt-2 border border-[#ff7300] text-[#ff7300] px-5 py-3 text-sm font-medium tracking-wider text-center"><Calendar size={18} /> Prendre rendez-vous en ligne</a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
